import { useQuery } from "@tanstack/react-query";
import { memberEquities, aspenApi as api } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { MEMBER_EQUITY_TYPE } from "@aspen/model";
import type { IMemberEquity } from "@aspen/model";

/**
 * 获取当前用户的Money Market权益
 * @returns {string | undefined} Money Market权益的params值，如果不存在则返回undefined
 */
export const useFetchMemberMoneyMarketEquities = () => {
  const equityType = MEMBER_EQUITY_TYPE.MONEY_MARKET_REWARDS;
  const apiPath = api.member.replace(/{equityType}/, equityType);
  const queryKey = generateDataCacheKey({
    api: apiPath,
    params: JSON.stringify({ equityType }),
  });
  const { data } = useQuery({
    queryKey: [queryKey, equityType],
    queryFn: () => {
      return memberEquities(equityType).then(res => {
        if (res?.code === "0") {
          return res.data as IMemberEquity[];
        }
        return undefined;
      });
    },
    retry: 3,
  });
  if (!data || data.length === 0) {
    return undefined;
  }
  const moneyMarketMemberEquities = data.find(
    item => item.type === MEMBER_EQUITY_TYPE.MONEY_MARKET_REWARDS,
  );

  return moneyMarketMemberEquities?.params;
};
